import Select from 'react-select';
import { Grid, Typography, Icon } from '@mui/material';
import { useController } from 'react-hook-form';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useLanguage } from '../LanguageContext';

const Dropdown = ({
	control,
	defaultValue = null,
	direction = 'RTL',
	disabled = false,
	isSearchable = true,
	label = '',
	name,
	options,
	placeholder = '',
	rules,
}) => {
	const { locale } = useLanguage();

	const { field, fieldState } = useController({
		control,
		name,
		defaultValue,
		disabled,
		rules,
	});
	return (
		<Grid
			display={'grid'}
			gap={'4px'}
			height={'max-content'}
		>
			<Typography
				variant="label"
				fontSize={'16px'}
				color={'#393733'}
			>
				{label}
			</Typography>
			<Select
				{...field}
				components={{
					DropdownIndicator,
				}}
				isClearable={false}
				isSearchable={isSearchable}
				direction={locale === 'fa' ? true : false}
				options={options}
				placeholder={placeholder}
				unstyled
				styles={{
					control: () => ({
						display: 'flex',
						background: '#FFF5E0',
						color: '#393733',
						border: '1px solid #FFBF3F',
						padding: '0 6px',
						height: '32px',
						borderRadius: '4px',
						fontSize: '14px',
					}),
					menu: () => ({
						position: 'absolute',
						width: '100%',
						background: '#FFF5E0',
						border: '1px solid #FFBF3F',
						padding: '6px',
						borderRadius: '4px',
						zIndex: 10,
					}),
					menuList: () => ({
						display: 'grid',
						gap: '4px',
					}),
					option: (_, { isSelected, isFocused }) => ({
						fontSize: '14px',
						fontWeight: isSelected ? 900 : 500,
						cursor: 'pointer',
						background: isFocused
							? '#FFBF3F99'
							: isSelected
							? '#FFBF3F'
							: 'transparent',
						padding: '4px 8px',
						borderRadius: '2px',
					}),
				}}
			/>
			{fieldState?.error && (
				<Typography
					variant="span"
					color="#d82c0d"
					fontSize={'14px'}
				>
					{fieldState?.error?.message}
				</Typography>
			)}
		</Grid>
	);
};

const DropdownIndicator = () => {
	return (
		<Icon>
			<KeyboardArrowDownIcon />
		</Icon>
	);
};

export default Dropdown;
